import { hotTopics } from "@/mocks/gossipData";

export default function HotTopics() {
  return (
    <section id="hot" className="mx-auto max-w-[1360px] scroll-mt-20 px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="font-display text-xs font-semibold uppercase tracking-[0.25em] text-sign-600">
            Trending Board
          </p>
          <h2 className="mt-2 font-heading text-2xl font-black text-ink-950 md:text-3xl">
            今日瓜场 · 谁在霸榜
          </h2>
          <p className="mt-2 max-w-2xl text-sm leading-7 text-ink-500">
            由真瓜研究所每四个小时盘点一次。排名依据讨论热度、证据完整度与新增线索量加权，而非单纯转发量。
          </p>
        </div>
        <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-melon-100 px-3 py-1.5 text-xs font-semibold text-melon-700">
          <i className="ri-time-line" />
          每小时自动刷新
        </span>
      </div>

      <div className="mt-7 grid gap-3 lg:grid-cols-2">
        {hotTopics.map((t, i) => (
          <a
            key={t.title}
            href="#topic"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("topic")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="group flex items-center gap-4 rounded-xl border border-ink-800/10 bg-paper-50 p-4 transition-colors hover:border-sign-300 hover:bg-paper-100/60"
          >
            <span className="flex w-8 shrink-0 flex-col items-center">
              <span className="font-display text-2xl font-bold leading-none text-ink-400 transition-colors group-hover:text-sign-600">
                {String(i + 1).padStart(2, "0")}
              </span>
            </span>
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-sign-100 text-sign-600">
              <i className={`text-lg ${i === 0 ? "ri-fire-fill" : "ri-flashlight-line"}`} />
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <span className="rounded bg-ink-900 px-1.5 py-0.5 text-[11px] font-semibold text-paper-50">
                  {t.tag}
                </span>
                <span
                  className={`rounded px-1.5 py-0.5 text-[11px] font-semibold ${
                    t.badge === "高烧"
                      ? "bg-sign-500 text-paper-50"
                      : "bg-sun-100 text-sun-800"
                  }`}
                >
                  {t.badge}
                </span>
              </div>
              <p className="mt-1.5 truncate text-sm font-semibold text-ink-800 transition-colors group-hover:text-sign-700">
                {t.title}
              </p>
            </div>
            <div className="flex shrink-0 flex-col items-end gap-1.5">
              <span className="font-display text-lg font-bold text-ink-900">
                {(t.heat / 1000).toFixed(1)}k
              </span>
              <span className="flex items-center gap-1 text-[11px] text-melon-600">
                <i className="ri-fire-fill" /> 热度
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}